/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from 'react'
import type { CustomBanner, CustomBannerInput } from 'api/generated'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'

export const EditCustomBannerForm: React.FC<{
  banner: CustomBanner | null
  onUpdate: (id: number, data: CustomBannerInput) => void
}> = ({ banner, onUpdate }) => {
  const [id, setId] = useState<number | null>(null)
  const [destination, setDestination] = useState('')
  // Current image URL from the API, or the data URI of a newly picked file
  const [image, setImage] = useState<string | null>(null)

  useEffect(() => {
    if (banner) {
      setId(banner.id)
      setDestination(banner.destination ?? '')
      setImage(banner.image)
    }
  }, [banner])

  const isValid = () => (image == null || image !== '') && destination !== ''

  const handleSave = (event: React.FormEvent) => {
    event.preventDefault()
    if (id === null) return
    // Only upload the image when a new file was picked (base64 data URI):
    // the existing value is a URL, not an upload.
    if (image?.startsWith('data:')) onUpdate(id, { destination, image })
    else onUpdate(id, { destination })
  }

  interface FileInputEvent extends React.ChangeEvent<HTMLInputElement> {
    target: HTMLInputElement & { files: FileList }
  }

  const handleFile = (event: FileInputEvent): void => {
    event.preventDefault()

    const file = event.target.files[0]
    const reader = new FileReader()

    reader.onloadend = () => setImage(reader.result as string)
    reader.readAsDataURL(file)
  }

  return (
    <form className='flex flex-col gap-10'>
      <p className='max-w-2xl'>
        <strong>Immagine:</strong>{' '}
        {image && <img src={image} alt='Custom Banner' />}
        <Input type='file' onChange={handleFile} />
      </p>
      <p className='max-w-2xl'>
        <strong>Destinazione:</strong>
        <Input
          type='text'
          value={destination}
          onChange={(event) => setDestination(event.target.value)}
        />
      </p>
      <Button className='max-w-2xl' onClick={handleSave} disabled={!isValid()}>
        Salva
      </Button>
    </form>
  )
}
